import * as React from 'react';
import { DomainWithFilespaces, FilespaceExtended } from 'fs-api-client';
import { FilespaceDetails } from '../filespace/FilespaceDetails';

interface BackOfficeUserFilespacesProps {
    domain?: DomainWithFilespaces;
    securityScopes?: string [];
}

interface BackOfficerUserFilespacesState {

}

export class UserFilespaces extends React.Component<BackOfficeUserFilespacesProps, BackOfficerUserFilespacesState> {
    constructor(props: BackOfficeUserFilespacesProps) {
        super(props);
        this.state = {
            isCopyButtonClicked: false
        };
        this.renderFilespacesSearchResults = this.renderFilespacesSearchResults.bind(this);
    }

    render() {
        return (
            <React.Fragment>
                {this.renderFilespacesSearchResults()}
            </React.Fragment>
        );
    }

    private renderFilespaceSearchResult(domainName: string, filespace: FilespaceExtended, index: number, securityScopes?: string[]): JSX.Element {
        return (
            <FilespaceDetails
                key={index}
                index={index}
                filespace={filespace}
                domainName={domainName}
                securityScopes={securityScopes}
            />
        );
    }

    private renderFilespacesSearchResults(): JSX.Element {
        if (!this.props.domain) {
            const noDomainMessage = 'This user has not created a domain yet.';
            return (
                <p> {noDomainMessage}</p>
            );
        }
        return (
            <React.Fragment>
                {this.props.domain.filespaces.length === 0 && <p>Domain "{this.props.domain.name}" has no Filespaces.</p>}
                {this.props.domain.filespaces.map((filespace: FilespaceExtended, index: number) => {
                    if (this.props.domain) {
                        return this.renderFilespaceSearchResult(this.props.domain.name, filespace, index, this.props.securityScopes);
                    }
                    return <></>;
                })}
            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/backoffice/components/user/UserFilespaces.tsx